import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "../lib/brand";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={buildWhatsAppLink(
        "Hello Qamar Al Zahran! I have a question about your products."
      )}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
      <span className="relative flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-110 transition-transform">
        <MessageCircle className="h-7 w-7" />
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-brand-brown text-brand-ivory text-xs px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity hidden sm:inline-block">
        Chat with us
      </span>
    </a>
  );
};
